/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.7.12",
    versionName: "0.4.0-nightly.2026.7.12",
    versionChannel: "nightly",
    buildDate: "2026-07-12T00:27:25.061Z",
    commitHash: "f3a03138add3b596e8326eae320de1c8b494d897",
};
